import PopupComponent from '../popup-component';
import template from './template';

export default class PairHelpPopup extends PopupComponent {
  constructor(config) {
    super();
    this.popup = null;

    const popupConfig = {
      id: 'popup_content_pairing_help_2019',
      buttons: [
        {
          id: 'cancel',
          class: 'negative',
          shouldClose: true,
          text: this.t('defaultPopupNegativeButton'),
          callback: () => config.onCancel(),
        },
        {
          id: 'continue',
          class: 'positive',
          shouldClose: true,
          text: this.t('defaultPopupContinueButton'),
          callback: () => config.onProceed(),
        },
      ],
    };

    this.popup = this.create(popupConfig);
    this.createContentElement('popup_content_pairing_help_2019', template);
  }
}
